import React from "react";

export default function RevirtClubMid() {
  return (
    <>
      <div className="section revirtclubmidoutercontainer">
        <div className="container">
          <div className="row justify-content-center">
            <p className="withrevirtclubyouget">with revirt.club you get</p>
            <div className="col-xl-8 col-lg-10 col-md-12 col-sm-12 col-12" style={{
              padding: 0,
              display: 'flex',
              justifyContent: 'center'
            }}>
              <div className="outer-card">
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 revirtclubmidcol order-xl-first order-lg-first order-md-first order-sm-last order-last">
                  <div>
                    <p>free lifetime access to revirt platform</p>
                    <p>
                      revirt makes virtual experiences more real, making
                      networking effective like no other platform.
                    </p>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 revirtclubmidcol revirtclubimgcol ">
                  <img src="https://firebasestorage.googleapis.com/v0/b/revirt-42522.appspot.com/o/website%2Frevirt%20club%2FGroup%203361.png?alt=media&token=41e5a27b-356b-4a59-acdc-ca10929c0143" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section revirtclubmidoutercontainer">
        <div className="container">
          <div className="row justify-content-center">
            <p className="withrevirtclubyouget">with revirt.club you get</p>
            <div className="col-xl-8 col-lg-10 col-md-12 col-sm-12 col-12" style={{
              padding: 0,
              display: 'flex',
              justifyContent: 'center'
            }}>
              <div className="outer-card">
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 revirtclubmidcol revirtclubimgcol">
                  <img src="https://firebasestorage.googleapis.com/v0/b/revirt-42522.appspot.com/o/website%2Frevirt%20club%2FGroup%203362.png?alt=media&token=29b15b63-cdc3-479f-bcab-8993a2223600" alt="" />
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 revirtclubmidcol">
                  <div>
                    <p>student network from top colleges</p>
                    <p>
                    to network with like minded individuals and learn skills from industry experts at the same time at the same time
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section revirtclubmidoutercontainer">
        <div className="container">
          <div className="row justify-content-center">
            <p className="withrevirtclubyouget">with revirt.club you get</p>
            <div className="col-xl-8 col-lg-10 col-md-12 col-sm-12 col-12" style={{
              padding: 0,
              display: 'flex',
              justifyContent: 'center'
            }}>
              <div className="outer-card">
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 revirtclubmidcol order-xl-first order-lg-first order-md-first order-sm-last order-last">
                  <div>
                    <p>weekly events by Industry experts</p>
                    <p>
                    to network with like minded individuals and learn skills from industry experts at the same time at the same time
                    </p>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 revirtclubmidcol revirtclubimgcol ">
                  <img src="https://firebasestorage.googleapis.com/v0/b/revirt-42522.appspot.com/o/website%2Frevirt%20club%2FGroup%203363.png?alt=media&token=5b645a66-2899-4e17-9520-8d2da2461317" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

